/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, memo } from 'react';
import Icons from '../../../configs/icon.config';
import './index.scss';

export interface CollapseButtonProps {
  icon?: React.ReactNode;
  iconHeight?: string;
  iconWidth?: string;
  iconColor?: string;
  className?: string;
}

function CollapseButton({
  icon,
  iconHeight,
  iconWidth,
  iconColor,
  className,
}: CollapseButtonProps) {
  const [isReversed, setIsReversed] = useState(false);

  const handleButtonClick = () => {
    setIsReversed(!isReversed);
  };

  const iconStyle = {
    height: iconHeight,
    width: iconWidth,
    color: iconColor,
    transform: isReversed ? 'scaleX(-1)' : 'scaleX(1)',
  };

  return (
    <div
      className={className}
      onClick={handleButtonClick}
      data-testid="collapse-button"
    >
      <div data-testid="collapse-icon">
        {React.cloneElement(icon as React.ReactElement, { style: iconStyle })}
      </div>
    </div>
  );
}

CollapseButton.defaultProps = {
  icon: Icons.rightArrow,
  iconHeight: '24px',
  iconWidth: '24px',
  iconColor: 'black',
};

export default memo(CollapseButton);
